import { createMachine } from "xstate";
import {
  fetchOrchestrators,
  IMultiOrderOrchestrator,
} from "@nju/data-access-portal-orchestrator";

type IEvent =
  | { type: "SUBMIT" }
  | { type: "ERROR" }
  | { type: "ANOTHER_ORDER_EXISTS" }
  | { type: "SUCCESS"; orchestrator: IMultiOrderOrchestrator | undefined };

export const postpaidOfferDetailsMachine = createMachine<IEvent>(
  {
    schema: {
      events: {} as IEvent,
    },
    initial: "start",
    states: {
      start: {
        on: {
          SUBMIT: {
            target: "checkOrchestrator",
          },
        },
      },
      checkOrchestrator: {
        invoke: {
          src: "fetchOrchestrator",
        },
        on: {
          SUCCESS: {
            actions: "onSubmit",
          },
          ANOTHER_ORDER_EXISTS: {
            actions: "onAnotherOrderExists",
            target: "start",
          },
          NO_PESEL: {
            actions: "onNoPesel",
            target: "start",
          },
          UNDER_18: {
            actions: "onUnder18",
            target: "start",
          },
          TECHNICAL_VERIFICATION_PENDING: {
            actions: "onTechnicalVerificationPending",
            target: "start",
          },
          ERROR: {
            target: "start",
          },
        },
      },
    },
  },
  {
    services: {
      fetchOrchestrator: () => {
        return async (callback) => {
          try {
            const orchestrators = (await fetchOrchestrators()).unwrap();
            const isMultiorderInProgress =
              orchestrators.multiOrder &&
              orchestrators.multiOrder.state !== "START";
            const isFtthInProgress =
              orchestrators.ftth && orchestrators.ftth.orderStatus === "Draft";
            const postpaidEligibility =
              orchestrators.multiOrder?.eligibilityDetails?.find((detail) => {
                return detail.offerCategory === "MOBILE_POSTPAID";
              });

            if (!postpaidEligibility?.eligible) {
              if (
                postpaidEligibility?.reasonCode === "NATIONALITY_RESTRICTION"
              ) {
                return callback({
                  type: "NO_PESEL",
                });
              }
              if (postpaidEligibility?.reasonCode === "AGE_RESTRICTION") {
                return callback({
                  type: "UNDER_18",
                });
              }
              if (
                postpaidEligibility?.reasonCode ===
                "TECHNICAL_VERIFICATION_PENDING"
              ) {
                return callback({
                  type: "TECHNICAL_VERIFICATION_PENDING",
                });
              }
            }

            if (isMultiorderInProgress || isFtthInProgress) {
              return callback({
                type: "ANOTHER_ORDER_EXISTS",
              });
            }

            return callback({
              type: "SUCCESS",
              orchestrator: orchestrators.multiOrder,
            });
          } catch {
            callback({ type: "ERROR" });
          }
        };
      },
    },
  },
);
